import { Box, Stack } from '@mantine/core';
import { SettingsSwitch } from '@repo/common/components';
import { Title } from '@repo/foundations';
import { useUpdateIntegration, type IIntegration } from '../../../../../api';

interface PowerBiPreferencesProps {
	integration: IIntegration;
}

export function PowerBiPreferences({ integration }: PowerBiPreferencesProps) {
	const { mutateAsync: updateIntegration } = useUpdateIntegration({});

	const enableAppEmbedding =
		integration.properties?.enable_app_embedding === 'true' ||
		integration.properties?.enable_app_embedding === undefined;

	const servicePrincipalEmbedding =
		integration.properties?.service_principal_embedding === 'true';

	const handleToggleAppEmbedding = (checked: boolean) => {
		const properties = {
			...(integration?.properties ?? {}),
			enable_app_embedding: String(checked),
		};
		updateIntegration({
			data: { id: integration.id, properties },
		});
	};

	const handleToggleServicePrincipal = (checked: boolean) => {
		const properties = {
			...(integration?.properties ?? {}),
			service_principal_embedding: String(checked),
		};
		updateIntegration({
			data: { id: integration.id, properties },
		});
	};

	return (
		<Stack spacing="md">
			<Title size="md">PowerBI Preview</Title>
			<Box>
				<SettingsSwitch
					title="Enable app embedding"
					description="Allow PowerBI apps to be embedded in Secoda. When disabled, apps will open in Power BI. Note: Users will need access to all reports within an embedded app."
					checked={enableAppEmbedding}
					onChange={handleToggleAppEmbedding}
				/>
			</Box>
			<Box>
				<SettingsSwitch
					title="Embed dashboards using service principal"
					description="Allow embeds to use service principal credentials. Users can view dashboards without logging into PowerBI, but will be able to view all dashboards they have access to inside Secoda."
					checked={servicePrincipalEmbedding}
					onChange={handleToggleServicePrincipal}
				/>
			</Box>
		</Stack>
	);
}
